import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute() {
  const { currentUser, userData, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-zinc-950">
        <Loader2 className="w-10 h-10 animate-spin text-primary-600" />
      </div>
    );
  }

  // If there's no authenticated user, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is admin
  if (userData?.role !== 'admin') {
    if (userData?.role === 'instructor') {
      return <Navigate to="/instructor-dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  // If authenticated and admin, render the child routes
  return <Outlet />;
}
